import { useEffect } from 'react';
import { SubmitButton } from 'framework/ui/ui-builder';
import { Alert, Button } from 'framework/ui/mui-builder';
import { useFormContext } from 'framework/form';
import { VacancyByGroupDropdown } from 'domain/shared/newVacancy';
import hiredFormValidationSchema from './hiredFormValidationSchema';
import { Box } from '@mui/material';

interface HiredStageFormProps {
  handleCancelClick: () => void;
  vacancyGroupId: string | null;
  entity: any;
}

const HiredStageForm = ({ handleCancelClick, vacancyGroupId, entity }: HiredStageFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact, setValidationSchemaAction } = useFormContext();
  const isHiringLimitReached = entity.hired >= entity.needHire;

  useEffect(() => {
    if (setValidationSchemaAction) {
      setValidationSchemaAction(hiredFormValidationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <VacancyByGroupDropdown
        source="vacancyId"
        label="Vacancy"
        vacancyGroupId={vacancyGroupId}
        placeholder="Select Vacancy..."
        helpText="Empty dropdown indicates that the vacancy needs to be migrated to the new Recruiting service first."
      />
      {isHiringLimitReached && (
        <Alert variant="outlined" severity="warning">
          {`Cannot hire more candidates. Current: ${entity.hired}, Maximum: ${entity.needHire}`}
        </Alert>
      )}

      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact || isHiringLimitReached}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default HiredStageForm;
